module.exports = __webpack_public_path__ + "img/xl_hn.7b83aa94.png";